export const navigate = (location: string) => {
    window.history.pushState(undefined, "", location);
};
